<template>
    <div>
        <div class="vote-success confirmation" v-if="success">
            <p>
                Váš hlas prosím potvrďte kliknutím na odkaz,<br/>
                který Vám během chvilky dorazí do e-mailové schránky. Děkujeme!
            </p>
        </div>
        <form v-on:submit.prevent="onSubmit" v-if="!success">
            <input type="email" v-model="email" placeholder="Váš e-mail pro ověření"/>
            <input type="submit" :value="processing ? 'Odesílám...' : 'Odeslat'"/>
            <div class="error-message" v-if="error">
                <p>{{error}}</p>
            </div>
        </form>
    </div>
</template>

<script>
    import isUndefined from 'lodash/isUndefined';
    import {isEmail} from '../../helpers/validation';
    import {vote} from './api/vote';

    export default {
        name:    'ReconstructionChallengeVoteForm',
        data:    () => {
            return {
                email:      null,
                processing: false,
                success:    false,
                error:      false,
            }
        },
        methods: {
            onSubmit() {
                if (this.isValid()) {
                    this.processing = true;
                    vote({
                        email: this.email,
                        slug:  this.getSlug(),
                    })
                    .then(() => this.success = true)
                    .catch((e) => {
                        const { data: { error } } = e.response;
                        if (!isUndefined(error)) {
                            this.error = error;
                        } else {
                            this.error = 'Váš hlas nepodařilo odeslat, zkuste to, prosím, znovu';
                        }
                    })
                    .finally(() => this.processing = false);
                }
            },
            isValid() {
                this.error = null;

                if (!this.email || this.email.length === 0) {
                    this.error = 'Zadejte váš email';
                    return false;
                }
                if (!isEmail(this.email)) {
                    this.error = 'Zadejte e-mail ve správném tvaru';
                    return false;
                }
                return true;
            },
            getSlug() {
                const { slug } = this.$route.params;
                return slug;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/reconstruction-challenge/VoteForm.vue